import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import * as React from 'react';

export const NullableTooltip: React.FC<TooltipProps> = ({
  children,
  ...props
}) => {
  if (!props.title) {
    return children;
  }

  return <Tooltip {...props}>{children}</Tooltip>;
};
